import DialogActions from '@material-ui/core/DialogActions';
import ActionModal from 'components/common/ActionModal/ActionModal';
import { Button, BUTTON } from '../../../../components/common/Button/Button';

import styles from './IncompleteModal.scss';

const { BGCOLOR, COLOR, OUTCOLOR } = BUTTON;

export const IncompleteModal = ({
    isOpen,
    onClose,
    onSave,
}) => {
    return <ActionModal
        isOpen={isOpen}
        onClose={onClose}
        onSave={onSave}
        title='Are you sure you want to activate this study?'
        CustomModalFooter={<IncompleteModalButtons onSave={onSave} onClose={onClose}/>}
    >
        <IncompleteModalHelperText />
    </ActionModal>;
};

const IncompleteModalHelperText = () => 'You have left some Study Setup values blank. You will not be able to file documents that require one of these values until they are filled in on this page.';

const IncompleteModalButtons = ({ onClose, onSave }) => {
    return (
        <DialogActions className={styles.incompleteModalBtn} data-cy="IncompleteModal">
            <Button
                outline={OUTCOLOR.LIGHTGREY}
                onClick={onClose}
                bgcolor={BGCOLOR.CLEAR}
                color={COLOR.GREY}
                data-cy="IncompleteModal-Cancel"
            >
                Cancel
            </Button>
            <div className={styles.btnRight} data-cy="IncompleteModal-BtnBlock">
                <Button
                    onClick={onSave}
                    bgcolor={BGCOLOR.ORANGE}
                    color={COLOR.WHITE}
                    data-cy="IncompleteModal-Ok"
                >
                Ok
                </Button>
            </div>
        </DialogActions>
    );
};